import React from "react";

const Social = () => {
	return (
		<div className="home__social">
			<a
				href="https://www.instagram.com/yash_agarwal08/"
				className="home__social-icon"
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="uil uil-instagram"></i>
			</a>
			{/* <a href="https://twitter.com/Yash_agarwal02" className="home__social-icon" target="_blank">
            <i className="uil uil-twitter-alt"></i>
        </a> */}
			<a
				href="https://www.linkedin.com/in/yash-agarwal08/"
				className="home__social-icon"
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="uil uil-linkedin"></i>
			</a>
			<a
				href="https://github.com/yashagarwal0812"
				className="home__social-icon"
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="uil uil-github-alt"></i>
			</a>
		</div>
	);
};

export default Social;
